import React, { useEffect, useRef, useState } from 'react';
import './guest.css';
import { useGuestCopy } from './guestCopy';

let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => { script.remove(); scriptPromise = null; reject(new Error('Verification could not load. Check your connection or sign in.')); };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export default function GuestVerification({ challenge, onClose }) {
  const copy = useGuestCopy();
  const container = useRef(null);
  const cancel = useRef(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let disposed = false;
    let widget;
    const previousFocus = document.activeElement;
    cancel.current?.focus();
    loadTurnstile().then((turnstile) => {
      if (disposed) return;
      widget = turnstile.render(container.current, {
        sitekey: challenge.siteKey, action: 'guest_signup', theme: 'light',
        size: container.current.clientWidth < 300 ? 'compact' : 'normal',
        callback: (token) => { challenge.resolve(token); onClose(); },
        'error-callback': () => setError(copy.verifyError),
        'expired-callback': () => setError(copy.verifyExpired),
      });
    }).catch((e) => setError(e.message));
    return () => { disposed = true; if (widget !== undefined) window.turnstile?.remove(widget); previousFocus?.focus(); };
  }, [challenge, onClose, attempt, copy]);
  const close = () => { challenge.reject(new Error('Verification cancelled. Choose your file again when ready.')); onClose(); };
  return <div className="guest-overlay" onKeyDown={(e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    if (e.key === 'Tab') {
      const controls = [...e.currentTarget.querySelectorAll('button,iframe')];
      const first = controls[0]; const last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
      if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
    }
  }}><section className="guest-dialog" role="dialog" aria-modal="true" aria-labelledby="guest-check-title">
    <h2 id="guest-check-title">{copy.verifyTitle}</h2>
    <p>{copy.verifyBody}</p>
    <div ref={container} />
    {error && <p role="alert">{error} <button onClick={() => { setError(''); setAttempt(n => n + 1); }}>{copy.retry}</button></p>}
    <button ref={cancel} className="secondary-button" onClick={close}>{copy.cancel}</button>
  </section></div>;
}
